__turbopack_context__.v({
  "className": "geist_67d76b20-module__yOMf8W__className",
  "variable": "geist_67d76b20-module__yOMf8W__variable",
});
